import { useEffect, useRef, useCallback } from 'react';
import useCallbackRef from 'hooks/useCallbackRef';

// Utility helper for random number generation
export var random = function random(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
};

// Hook from https://www.joshwcomeau.com/snippets/react-hooks/use-random-interval/
// Generate random, "organic feeling", intervals for eg usage in animations (see Sparkles)
export default function useRandomInterval(callback, minDelay, maxDelay) {
  var timeoutId = useRef(undefined);
  var savedCallback = useCallbackRef(callback);
  useEffect(function () {
    var isEnabled = typeof minDelay === 'number' && typeof maxDelay === 'number';
    if (isEnabled) {
      var _handleTick = function handleTick() {
        var nextTickAt = random(minDelay, maxDelay);
        timeoutId.current = window.setTimeout(function () {
          savedCallback.current();
          _handleTick();
        }, nextTickAt);
      };
      _handleTick();
    }
    return function () {
      return window.clearTimeout(timeoutId.current);
    };
  }, [minDelay, maxDelay, savedCallback]);
  var cancel = useCallback(function () {
    window.clearTimeout(timeoutId.current);
  }, []);
  return cancel;
}